import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { PurchaseToast } from './components/PurchaseToast';
import { Nav } from './components/Nav';
import { Hero } from './components/Hero';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { ForWhom } from './components/ForWhom';
import { SystemOverview } from './components/SystemOverview';
import { Modules } from './components/Modules';
import { Bonuses } from './components/Bonuses';
import { Comparison } from './components/Comparison';
import { Pricing } from './components/Pricing';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-cream selection:bg-gold-500/30 selection:text-navy-900" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <PurchaseToast data-id="element-2" />
      <Nav data-id="element-3" />
      <main data-id="element-4">
        <Hero data-id="element-5" />
        <Testimonials data-id="element-6" />
        <PainPoints data-id="element-7" />
        <ForWhom data-id="element-8" />
        <SystemOverview data-id="element-9" />
        <Modules data-id="element-10" />
        <Bonuses data-id="element-11" />
        <Comparison data-id="element-12" />
        <Pricing data-id="element-13" />
        <Guarantee data-id="element-14" />
        <FAQ data-id="element-15" />
        <FinalCTA data-id="element-16" />
      </main>
      <Footer data-id="element-17" />
    </div>;
}